import { Component, OnInit, ViewContainerRef, HostListener } from '@angular/core';
import { PriceType, Product } from '../../../models/product';
import { Onboarding } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';
import { Duration, LightRate } from '../../../models/product';
import { CustomModalComponent } from '../../dialogs/custom-modal/custom-modal.component';
import { ModalDialogService, IModalDialogButton, IModalDialog, IModalDialogOptions } from 'ngx-modal-dialog';
import { UtilsService } from '../../../services/utils.service';
import { ComponentRef } from '@angular/core';
import { AlgGtmService } from '../../../services/alg-gtm.service';

@Component({
  selector: 'alg-product-card',
  templateUrl: './alg-product-card.component.html',
  styleUrls: ['./alg-product-card.component.scss'],
})
export class AlgProductCardComponent implements OnInit {
  public duration: any[] = [];
  public lightrate: any[] = [];
  public product: Product;
  public secondProduct: Product;
  public modal;
  public disable;
  public isChecked;
  public greenEnergy = false;
  public isClicked = false;
  public isClickedRecap: boolean;
  public showInfoLuce = false;
  public showInfoGas = false;
  public screenWidth: any;
  public changeDeal: boolean;
  public changeAppearance: boolean;
  public isTablet: boolean;
  public promoText: string;
  public currentOnboarding: Onboarding = {} as Onboarding;
  public productValidity: string;
  public lightDescription: string;
  public gasDescription: string;
  public gasPrice: string;
  public isPlacet: boolean;

  // PRICES FIXED & VARIABLE
  public lightCommercializePrice = '65,44 €/anno';
  public gasCommercializePrice = '62,74 €/Smc';
  public gasVariablePrice = '0,007946 €/Smc';
  public isPriceVariable: boolean;

  actionButtons: IModalDialogButton[];

  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private gtm: AlgGtmService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth > 767 && this.screenWidth < 993) {
      this.isTablet = true;
    } else {
      this.isTablet = false;
    }
  }

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct, this.api.promotions, this.api.currentLightGreen)
      .subscribe(([onboarding, product, promotions, lightGreen]) => {
        this.currentOnboarding = onboarding;
        this.greenEnergy = lightGreen;
        this.product = product;
        this.greenEnergy = lightGreen;
        this.gasPrice = product.gasPrice;
        this.isPriceVariable = product.priceType === 'Variabile' ? true : false;
        this.setRadiosValue();
        this.productValidity = product.validity ? product.validity.replace(/fino al/g, '') : '';
        const currentPromo = promotions.find((p) => p.code === this.currentOnboarding.promoCode);
        if (currentPromo) {
          this.promoText = product.type === 'Luce & Gas' ? currentPromo.descriptionBi : currentPromo.descriptionMono;
        }
        if (this.product && this.product.type && this.product.type.toLowerCase().indexOf('luce') > -1) {
          this.showInfoLuce = true;
        }
        if (this.product && this.product.type && this.product.type.toLowerCase().indexOf('gas') > -1) {
          this.showInfoGas = true;
        }

        if (product.family) {
          this.isPlacet = product.family.name.toLowerCase() === 'placet';
        }
        if (product.type === 'Luce & Gas') {
          this.lightDescription = product.family.dualLightDescription;
          this.gasDescription = product.family.dualGasDescription;
        }
        if (product.type === 'Luce') {
          if (product.family.name.toLowerCase() !== 'placet') {
            this.lightDescription = product.family.monoLightDescription;
          } else {
            if (product.priceType === PriceType.fisso) {
              this.lightDescription = product.family.monoLightPlacetFissoDescription;
            }
            if (product.priceType === PriceType.variabile) {
              this.lightDescription = product.family.monoLightPlacetVariabileDescription;
            }
          }
        }
        if (product.type === 'Gas') {
          if (product.family.name.toLowerCase() !== 'placet') {
            this.gasDescription = product.family.monoGasDescription;
          } else {
            if (product.priceType === PriceType.fisso) {
              this.gasDescription = product.family.monoGasPlacetFissoDescription;
            }
            if (product.priceType === PriceType.variabile) {
              this.gasDescription = product.family.monoGasPlacetVariabileDescription;
            }
          }
        }
      });

    this.screenWidth = window.innerWidth;
    if (this.screenWidth > 767 && this.screenWidth < 992) {
      this.isTablet = true;
    } else {
      this.isTablet = false;
    }

    this.isClickedRecap = true;
  }

  private setRadiosValue() {
    if (this.product.durationChangeable) {
      this.duration = [
        { label: '12 Mesi', value: Duration.m12 },
        { label: '24 Mesi', value: Duration.m24 },
      ];
    }
    if (this.product.lightRateChangeable) {
      this.lightrate = [
        { label: 'Monoraria', value: LightRate.mono },
        { label: 'Bioraria', value: LightRate.bi },
      ];
    }
    if (!this.product.durationChangeable) {
      this.duration = [{ label: this.product.duration, value: this.product.duration }];
    }
    if (!this.product.lightRateChangeable && this.product.lightRate) {
      this.lightrate = [{ label: this.product.lightRate, value: this.product.lightRate }];
    }
  }

  openModal() {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Riepilogo dell'offerta`,
      childComponent: CustomModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
      },
      data: {
        text: 'Some text content',
      },
    });
  }

  public changeDuration(event) {
    let familyId = '';
    if (typeof this.product.family === 'object') {
      familyId = this.product.family._id;
    } else {
      familyId = this.product.family;
    }
    const filters: any = {
      duration: event.target.value,
      type: this.product.type,
      family: familyId,
    };
    if (this.product.lightRate) {
      filters.lightRate = this.product.lightRate;
    }
    this.api.updateNextProduct(filters);
    if (this.screenWidth > 767) {
      this.openModal();
    } else {
      this.changeDeal = true;
      this.api.nextProduct.combineLatest(this.api.currentLightGreen).subscribe(([product, lightGreen]) => {
        this.secondProduct = product;
        this.greenEnergy = lightGreen;
      });
      this.changeAppearance = true;
    }
  }

  public changeLightRate(event) {
    let familyId = '';
    if (typeof this.product.family === 'object') {
      familyId = this.product.family._id;
    } else {
      familyId = this.product.family;
    }
    this.api.updateNextProduct({
      duration: this.product.duration,
      type: this.product.type,
      family: familyId,
      lightRate: event.target.value,
    });
    if (this.screenWidth > 767) {
      this.openModal();
    } else {
      this.changeDeal = true;
      this.api.nextProduct.combineLatest(this.api.currentLightGreen).subscribe(([product, lightGreen]) => {
        this.secondProduct = product;
        this.greenEnergy = lightGreen;
      });
      this.changeAppearance = true;
    }
  }

  public changeGreenEnergy(value) {
    this.api.currentLightGreen.next(value);
  }

  dialogInit(reference: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<any>>) {
    this.actionButtons = [
      {
        text: '',
        buttonClass: 'alg-btn-close',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
    ];
    options.actionButtons = this.actionButtons;
  }

  openRecap() {
    this.isClicked = false;
    this.isClickedRecap = !this.isClickedRecap;
  }

  openEdit() {
    this.isClicked = !this.isClicked;
    this.isClickedRecap = !this.isClickedRecap;
  }

  refresh() {
    this.changeDeal = false;
    this.api.refreshCurrentProduct();
  }

  reUpload() {
    this.gtm.submitOnbEvent('Modifica Offerta', this.product.name);
    this.api.nextToCurrentProduct();
    this.changeDeal = false;
  }

  downloadCTE() {
    const options = {
      product: this.currentOnboarding.product.name || this.product.name,
      promo: !this.currentOnboarding.promoCode || this.currentOnboarding.promoCode.length === 0 ? null : this.currentOnboarding.promoCode,
      offerType: 'ALG',
      priceTypology: this.currentOnboarding.product.priceType || this.product.priceType,
      placet: this.currentOnboarding.product.source || this.product.source,
      commodity: this.currentOnboarding.product.type || this.product.type,
      duration:
        this.product.name.includes('CASA AGILE') || this.product.name.includes('CASA AGILE ECOLOGICA')
          ? '12'
          : this.product.duration.replace(' Mesi', '') || this.currentOnboarding.product.duration.replace(' Mesi', ''),
      renew: null,
    };
    return this.api
      .getCTE(options)
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        alert('Error');
      });
  }

  downloadPdf(data) {
    let newBlob = new Blob([data], { type: 'application/pdf' });
    let url = window.URL.createObjectURL(newBlob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-product-card/alg-product-card.component.ts